import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  dropzoneContainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 12,
    color: '#0E1247',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  inputError: {
    border: `2px solid ${theme.palette.error.main}`,
  },
  thumbsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    position: 'relative',
  },
  thumb: {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    width: 150,
    [theme.breakpoints.down('md')]: {
      width: 125,
    },
  },
  thumbInner: {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
  },
}));